<app-filter-header title="Filtrar seguretat usuaris" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-text-edit id="seguretat-usuaris-filter-codi" class="col-md-3" i18n-label label="Codi" [(value)]="filter.codiUser" number maxLenght="7"></app-form-text-edit>
    <app-filter-text-edit id="seguretat-usuaris-filter-nom" class="col-sm-3" i18n-label label="Nom usuari" [(value)]="filter.nomUsuari"></app-filter-text-edit>
    <app-filter-text-edit id="seguretat-usuaris-filter-descripcio" class="col-sm-3" i18n-label label="Descripció" [(value)]="filter.descripcio" contains></app-filter-text-edit>
  </div>
</div>
